module.exports = __webpack_public_path__ + "img/icons/attachment-upload/error-d3cea350e72ec1a35a085e78fb64164e.svg";